var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStampUnpaid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 76C55.8823 76 72 59.8823 72 40C72 20.1178 55.8823 4 36 4C16.1178 4 0 20.1178 0 40C0 59.8823 16.1178 76 36 76Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 71C59.33 71 75 55.33 75 36C75 16.67 59.33 1 40 1C20.67 1 5 16.67 5 36C5 55.33 20.67 71 40 71Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1765 47.4118H42.7941C48.1545 47.4118 52.5 43.0663 52.5 37.7059C52.5 32.3455 48.1545 28 42.7941 28H30",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2427 24L28 28.2426L32.2427 32.4853",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampUnpaid);
export default __webpack_public_path__ + "static/media/ic-stamp-unpaid.35938b3d34c27b3bbb8c3f6d7ea9f68e.svg";
export { ForwardRef as ReactComponent };